import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import React, { useEffect, useState } from 'react'
import { mondayService } from '../services/mondayService'
import { utilService } from '../services/utilService'
import { freshService } from '../services/freshService'
import { useLoadFreshData } from '../hooks/useLoadFreshData'
const { Dropdown } = require('monday-ui-react-core')

interface MondayFieldsProps {
  isEditable: boolean
  mappingMondayFields: MondayFields
  onSetMapping: Function
  onSetBoardColumns: Function
  boardColumns: DropDownOption[]
  currentBoard: DropDownOption
  mappingServiceFields: ServiceRequestFields
  freshAccount: FreshAccount
  setFreshError: React.Dispatch<React.SetStateAction<boolean>>
  ticketType: string
  setUnfilledRequiredMonday: React.Dispatch<React.SetStateAction<string[]>>
  setMondayError: React.Dispatch<React.SetStateAction<boolean>>
}

export const MondayFields: React.FC<MondayFieldsProps> = ({ isEditable, mappingMondayFields, onSetMapping, onSetBoardColumns, boardColumns, currentBoard, mappingServiceFields, freshAccount, setFreshError, ticketType, setUnfilledRequiredMonday, setMondayError }) => {
  // const boards: DropDownOption[] = useGetMondayData('boards')

  const initialServiceFields: ServiceRequestFields = {
    catalog_id: mappingServiceFields.catalog_id || null,
    category_id: mappingServiceFields.category_id || null,
  }

  const initialmondayFields: MondayFields = {
    board: null,
    subject: null,
    requested_for: null,
    email: null,
    id_column: null,
    ticket_link: null
  }
  const [mondayFields, setMondayFields] = useState<MondayFields>(initialmondayFields)
  const [serviceRequestData, setServiceRequestData] = useState<any>({ categories: null, catalogs: null })
  const [serviceFields, setServiceFields] = useState<ServiceRequestFields>(initialServiceFields)

  useLoadFreshData(ticketType, freshAccount, setFreshError, setServiceRequestData)
  useEffect(() => {
    getDropDownColumn()
  }, [])

  useEffect(() => {
    getUnfilledMondayFields(mondayFields, serviceFields)
  }, [mondayFields, serviceFields])

  /**
   * The function checks the unfilled mendatory fields and dispatch it to the "Mapping" component to check if all required fields are filled while saving.
   */
  const getUnfilledMondayFields = (mondayFields: MondayFields, serviceFields: ServiceRequestFields): void => {
    const unfilledServiceFields = Object.keys(serviceFields).filter((field) => serviceFields[field as keyof ServiceRequestFields] === null)
      .map((fieldName) => utilService.convertMondayFieldName(fieldName)) // So that the names will be displayed properly.
    const unfilledMondayFields = Object.keys(mondayFields)
      .filter((field) => {
        if (ticketType === 'serviceRequest') {
          return mondayFields[field as keyof MondayFields] === null && (field !== 'subject' && field !== 'board' && field !== 'ticket_link')
        } else {
          return mondayFields[field as keyof MondayFields] === null && (field !== 'requested_for' && field !== 'board' && field !== 'ticket_link')
        }
      })
      .map((fieldName) => utilService.convertMondayFieldName(fieldName)) // So that the names will be displayed properly.

    if (ticketType === 'serviceRequest') {
      const unfilledMondayAndServiceRequest = unfilledMondayFields.concat(unfilledServiceFields)
      setUnfilledRequiredMonday(unfilledMondayAndServiceRequest)
    } else {
      setUnfilledRequiredMonday(unfilledMondayFields)
    }
  }





  useEffect(() => {
    mondayFields.board && onSetBoardColumns(mondayFields.board.value)
  }, [mondayFields.board])

  // RESETING WHEN CLEARING
  useEffect(() => {
    setMondayFields(initialmondayFields)
    setServiceFields(initialServiceFields)
  }, [mappingMondayFields])

  const getDropDownColumn = (): void => {
    Object.keys(mappingMondayFields).forEach(async (field: any): Promise<void> => {
      if (mappingMondayFields[field as keyof MondayFields]) {
        const columnTitle: DropDownOption | null | undefined = await mondayService.getColumnTitle(mappingMondayFields.board, field, mappingMondayFields[field as keyof MondayFields], setMondayError)
        const dropDownField: { label: DropDownOption; value: string | number } | null = columnTitle ? { label: columnTitle, value: mappingMondayFields.board } : null
        setMondayFields((mondayFields: MondayFields) => ({
          ...mondayFields,
          [field]: dropDownField,
        }))
      }
    })
  }

  const onSetMondayFields = (option: DropDownOption, field: string): void => {
    setMondayFields((mondayFields: MondayFields) => ({
      ...mondayFields,
      [field]: option,
    }))
    if (!option) mappingMondayFields[field as keyof MondayFields] = null
    else mappingMondayFields[field as keyof MondayFields] = option.value
    onSetMapping('mondayFields', mappingMondayFields)
  }

  const onSetServiceFields = (option: DropDownOption, field: string): void => {
    if (field === 'catalog_id' && option) {
      onSetCustomFields(option)
      onSetChildItems(option)
    }
    setServiceFields((serviceFields: ServiceRequestFields) => ({
      ...serviceFields,
      [field]: option,
    }))
    mappingServiceFields[field as keyof ServiceRequestFields] = option
    onSetMapping('serviceRequestFields', mappingServiceFields)
  }

  const loadFreshCatalogs = async (): Promise<void> => {

    const freshCatalogs = await freshService.getFreshData('catalog', freshAccount, serviceFields.category_id?.value)
    setServiceRequestData((serviceData: ServiceRequestFields) => ({
      ...serviceData,
      catalogs: freshCatalogs,
    }))
  }

  useEffect(() => {
    serviceRequestData && serviceFields.category_id && ticketType === 'serviceRequest' && loadFreshCatalogs()
  }, [serviceFields.category_id, serviceRequestData?.categories, ticketType])

  const onSetCustomFields = async (catalogOption: DropDownOption): Promise<void> => {
    const customFields = await freshService.getFreshItemData(freshAccount, catalogOption.value, 'customFields')
    if (customFields.length) {
      const mappedCustomFields = utilService.mappingCustomFields(customFields)
      onSetMapping('customFields', mappedCustomFields)
    } else onSetMapping('customFields', [])
  }

  const onSetChildItems = async (catalogOption: DropDownOption): Promise<void> => {
    const childItems = await freshService.getFreshItemData(freshAccount, catalogOption.value, 'childItems')
    if (childItems.length) {
      const mappedChildItems = childItems.map((childItem: any) => {
        return { ...childItem, customFields: utilService.mappingCustomFields(childItem.customFields) }
      })
      onSetMapping('childItems', mappedChildItems)
    } else onSetMapping('childItems', [])
  }

  return (
    <div className="dropdown-container board-integration">
      <h2>Board Integration</h2>
      <label>
        <p>
          Board: <span>*</span>
        </p>
        <Dropdown className="dropdown-wrapper" disabled={true} defaultValue={currentBoard} value={currentBoard} />
        <div className="tooltip">
          <span>
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
          <div className="tooltip-container">{'The board that the app is integrated to. Chosed automatically.'}</div>
        </div>
      </label>
      {ticketType === 'ticket' && (
        <label>
          <p>
            Subject: <span>*</span>
          </p>
          <Dropdown className="dropdown-wrapper" placeholder="Choose ticket subject" disabled={!isEditable} options={boardColumns?.length && boardColumns} onChange={(option: DropDownOption) => onSetMondayFields(option, 'subject')} value={mondayFields.subject} />
          <div className="tooltip">
            <span>
              <FontAwesomeIcon icon={faCircleInfo} />
            </span>
            <div className="tooltip-container">{'The subject of the email.'}</div>
          </div>
        </label>
      )}
      {ticketType === 'serviceRequest' && (
        <label>
          <p>
            Requested For: <span>*</span>
          </p>
          <Dropdown className="dropdown-wrapper"
            placeholder="Choose requested for"
            disabled={!isEditable}
            noOptionsMessage={() => 'Must be column type of email/person'}
            options={boardColumns?.length && boardColumns.filter((column: ExtendedDDOption) => column.type === 'email' || column.type === 'people')}
            onChange={(option: DropDownOption) => onSetMondayFields(option, 'requested_for')}
            value={mondayFields.requested_for}
          />
          <div className="tooltip">
            <span>
              <FontAwesomeIcon icon={faCircleInfo} />
            </span>
            <div className="tooltip-container">{'The user that the ticket will be assigned to. Must be of email column type.'}</div>
          </div>
        </label>
      )}
      <label>
        <p>
          Requester Email: <span>*</span>
        </p>
        <Dropdown className="dropdown-wrapper"
          placeholder="Choose email"
          disabled={!isEditable}
          noOptionsMessage={() => 'Must be column type of email/person'}
          options={boardColumns?.length && boardColumns.filter((column: ExtendedDDOption) => column.type === 'email' || column.type === 'people')}
          onChange={(option: DropDownOption) => onSetMondayFields(option, 'email')}
          value={mondayFields.email}
        />
        <div className="tooltip">
          <span>
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
          <div className="tooltip-container">{'The user that sending the ticket. Must be of email column type.'}</div>
        </div>
      </label>
      <label>
        <p>
          Ticket ID: <span>*</span>
        </p>
        <Dropdown className="dropdown-wrapper"
          placeholder="Choose column for Ticket ID"
          disabled={!isEditable}
          noOptionsMessage={() => 'Must be text/number column type'}
          options={boardColumns?.length && boardColumns.filter((column: ExtendedDDOption) => column.type === 'numbers' || column.type === 'long_text' || column.type === 'text')}
          onChange={(option: DropDownOption) => onSetMondayFields(option, 'id_column')}
          value={mondayFields.id_column}
        />
        <div className="tooltip">
          <span>
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
          <div className="tooltip-container">{'Fresh Ticket ID will be inside this column (Type: Text/Number)'}</div>
        </div>
      </label>
      <label>
        <p>
          Ticket Link:
        </p>
        <Dropdown 
          className="dropdown-wrapper"
          placeholder="Choose column for Ticket Link"
          disabled={!isEditable}
          noOptionsMessage={() => 'Must be link column type'}
          options={boardColumns?.length && boardColumns.filter((column: ExtendedDDOption) => column.type === 'link')}
          onChange={(option: DropDownOption) => onSetMondayFields(option, 'ticket_link')}
          value={mondayFields.ticket_link}
        />
        <div className="tooltip">
          <span>
            <FontAwesomeIcon icon={faCircleInfo} />
          </span>
          <div className="tooltip-container">{'After ticket sent you can append the ticket link into a link column'}</div>
        </div>
      </label>
      {ticketType === 'serviceRequest' && (
        <>
          <h2>Service Request</h2>
          <label>
            <p>
              Categories: <span>*</span>
            </p>
            <Dropdown
              className="dropdown-wrapper"
              disabled={!serviceRequestData.categories || !isEditable}
              placeholder="Categories"
              onChange={(option: DropDownOption) => onSetServiceFields(option, 'category_id')}
              options={serviceRequestData.categories && utilService.convertToDropDownOptions(serviceRequestData.categories)}
              value={serviceFields.category_id}
            />
            <div className="tooltip">
              <span>
                <FontAwesomeIcon icon={faCircleInfo} />
              </span>
              <div className="tooltip-container">{'Choose the category in the same way it is ordered on your FreshService account.'}</div>
            </div>
          </label>
          <label>
            <p>
              Catalog: <span>*</span>
            </p>
            <Dropdown
              className="dropdown-wrapper"
              disabled={!serviceFields?.category_id || !isEditable}
              placeholder="Choose catalog"
              options={serviceRequestData?.catalogs && utilService.convertToDropDownOptions(serviceRequestData.catalogs)}
              onChange={(option: DropDownOption) => onSetServiceFields(option, 'catalog_id')}
              value={serviceFields?.category_id ? serviceFields.catalog_id : null}
            />
            <div className="tooltip">
              <span>
                <FontAwesomeIcon icon={faCircleInfo} />
              </span>
              <div className="tooltip-container">{'The catalog/service item that the user will be assinged to.'}</div>
            </div>
          </label>
        </>
      )}
    </div>
  )
}
